import { Component, OnInit } from '@angular/core';
import { AppService } from '../app.service';
import { Router } from '@angular/router';
import { User } from '../models/user';
import { DomSanitizer } from '@angular/platform-browser';
import { Image } from '../models/image';
import { Location } from '@angular/common';
import { trigger, state, style, animate, transition } from '@angular/animations';

@Component({
  selector: 'app-bandeau',
  templateUrl: './bandeau.component.html',
  styleUrls: ['./bandeau.component.css'],
  animations: [
    trigger('photoAnim', [
      transition('active => inactive' , [
        style({opacity: 0}),
        animate('5s')
      ]),
      transition('inactive => active', [
        animate('5s 2s', style({transform: 'translateY(-100%)', opacity: 1}))
    ])
    ])
  ]
})
export class BandeauComponent implements OnInit {
  private idsPhotosComp: string[] = [];
  private idsPhotos: string[] = [];
  private range: number = 4;
  private photos: Image[] = [];
  private state: string = 'active';

  constructor(private appService: AppService, private router: Router, private sanitizer: DomSanitizer, private location: Location) { }

  ngOnInit() {
    this.appService.getPhotos().subscribe(photosLoad => {
      photosLoad.forEach(photo => {
        this.idsPhotosComp.push(photo.id_img_bandeau);
        photo.imgPath = this.sanitizer.bypassSecurityTrustUrl(photo.image);
        photo.image = null;
      });
      this.idsPhotos = this.idsPhotosComp.slice(this.range-4, this.range);
      this.appService.photos = Object.assign([], photosLoad);
      for (let idPhoto of this.idsPhotos) {
        let photoCour = this.appService.photos.filter(photo => photo.id_img_bandeau === idPhoto);
        this.photos.push(photoCour[0]);
      }
      this.range++;
    });
  }

  adminAccess() {
    if (this.router.isActive('admin', false)) {
      this.router.navigate(['accueil'], { skipLocationChange: true });
    } else {
      this.router.navigate(['admin'],  { skipLocationChange : true });
    }
  }

  majChiffres(obj: any) {
    this.range = obj.range;
  }

  deconnecter() {
    this.appService.userCourant = new User();
    window.location.assign("http://sagedijon.fr");
  }

  private photosAAfficher() {
    if (this.state === 'active') {
      this.photos=[];
      this.idsPhotos = this.idsPhotosComp.slice(this.range-4, this.range);
      for (let idPhoto of this.idsPhotos) {
        let photoCour = this.appService.photos.filter(photo => photo.id_img_bandeau === idPhoto);
        this.photos.push(photoCour[0]);
      }
      if (this.range >= this.idsPhotosComp.length) {
        this.range = 4;
      } else {
        this.range++;
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/bandeau/bandeau.component.ts